/* ============================================
   DOC'S ORIGINAL VITAMINS — MAIN JS
   Shopify Buy SDK Integration Ready
   ============================================ */

// ====== SHOPIFY CONFIGURATION ======
// To connect to your Shopify store, fill in these values:
// 1. Go to Shopify Admin → Settings → Apps and sales channels → Develop apps
// 2. Create an app, enable Storefront API access
// 3. Copy your Storefront Access Token and store domain below
const SHOPIFY_CONFIG = {
  domain: 'docsoriginal-com.myshopify.com',
  storefrontToken: 'eafd17f6dd03cd702e6246d4cc40872e',
  enabled: true
};

// ====== PRODUCT DATA (Fallback / Default) ======
// These serve as defaults when Shopify isn't connected yet.
// Once Shopify is connected, products are pulled from your store automatically.
const DEFAULT_PRODUCTS = {
  'digestive-enzymes': {
    id: 'digestive-enzymes',
    name: 'Digestive Enzymes with Betaine',
    price: 70,
    category: 'Digestive Health',
    image: '',  // Add local image path: 'images/products/digestive-enzymes.png'
    emoji: '💊',
    tag: 'Best Seller',
    shortDesc: 'Comprehensive enzyme blend to optimize digestion and nutrient absorption.',
    fullDesc: "Doc\u2019s Digestive Enzymes with Betaine is a comprehensive enzyme blend designed to support your body\u2019s natural digestive processes. Featuring Betaine HCl alongside a full spectrum of digestive enzymes, this formula helps optimize protein digestion, fat breakdown, and nutrient absorption \u2014 giving your gut the support it needs to function at its best.",
    ingredients: [
      'Betaine HCl (650mg)', 'Pepsin (40mg)', 'Ox Bile Extract (100mg)',
      'Pancreatin 8x (200mg)', 'Bromelain (100mg)', 'Papain (50mg)',
      'Lipase (30mg)', 'Amylase (30mg)', 'Cellulase (10mg)'
    ],
    benefits: [
      { title: 'Optimizes Protein Digestion', desc: 'Betaine HCl and Pepsin work synergistically to support healthy stomach acid levels and protein breakdown.' },
      { title: 'Enhances Nutrient Absorption', desc: 'A full spectrum of enzymes ensures your body can extract maximum nutrition from every meal.' },
      { title: 'Reduces Bloating & Discomfort', desc: 'Comprehensive enzyme support helps prevent the gas, bloating, and heaviness that come from incomplete digestion.' },
      { title: 'Supports Gut Health', desc: 'Ox Bile Extract aids fat digestion and supports a healthy gallbladder and liver connection.' }
    ],
    servingSize: '1 capsule with each meal',
    servings: '90 capsules (30-day supply)',
    reviews: [
      { name: 'Sarah M.', initial: 'S', stars: 5, date: 'Feb 2026', text: "I\u2019ve tried so many digestive enzymes over the years. Doc\u2019s formula is in a completely different league. My digestion has never been better." },
      { name: 'David K.', initial: 'D', stars: 5, date: 'Jan 2026', text: 'Finally a digestive enzyme that actually works. I can eat meals without worrying about bloating or discomfort afterwards.' },
      { name: 'Michelle R.', initial: 'M', stars: 5, date: 'Jan 2026', text: 'The betaine HCl makes a huge difference. I feel like I am actually absorbing my food now. Great quality product.' }
    ]
  },
  'endoslim': {
    id: 'endoslim',
    name: 'EndoSlim',
    price: 80,
    category: 'Metabolism Support',
    image: '',
    emoji: '🌿',
    tag: 'New',
    shortDesc: 'Herbal support for healthy metabolism and balanced endocrine function.',
    fullDesc: "EndoSlim is Doc\u2019s targeted formula for supporting healthy metabolic function and endocrine balance. This powerful blend combines time-tested herbs with clinically studied compounds to help your body naturally manage weight, balance blood sugar, and optimize metabolic performance \u2014 without stimulants or harsh ingredients.",
    ingredients: [
      'Berberine HCl (500mg)', 'Chromium Picolinate (200mcg)', 'Green Tea Extract (250mg)',
      'Gymnema Sylvestre (200mg)', 'Alpha Lipoic Acid (150mg)', 'Cinnamon Bark Extract (100mg)',
      'Bitter Melon Extract (100mg)', 'BioPerine (5mg)'
    ],
    benefits: [
      { title: 'Supports Healthy Metabolism', desc: 'A synergistic blend of herbs and compounds that work together to optimize your metabolic rate naturally.' },
      { title: 'Balances Blood Sugar', desc: 'Berberine, Chromium, and Cinnamon help maintain healthy blood sugar levels already within the normal range.' },
      { title: 'Promotes Weight Management', desc: "Gymnema Sylvestre and Green Tea Extract support your body\u2019s natural ability to maintain a healthy weight." },
      { title: 'Endocrine Support', desc: 'Targeted nutrients that nourish and support balanced endocrine function for overall hormonal wellness.' }
    ],
    servingSize: '2 capsules daily with food',
    servings: '60 capsules (30-day supply)',
    reviews: [
      { name: 'Jennifer L.', initial: 'J', stars: 5, date: 'Feb 2026', text: 'EndoSlim has been a game-changer for my metabolism. I have more energy and the scale is finally moving in the right direction.' },
      { name: 'Marcus T.', initial: 'M', stars: 5, date: 'Jan 2026', text: 'Love that this uses berberine instead of stimulants. Gentle but effective. My doctor was impressed with my bloodwork improvements.' },
      { name: 'Anna P.', initial: 'A', stars: 4, date: 'Dec 2025', text: 'Great product for metabolic support. I notice a real difference in my energy levels throughout the day.' }
    ]
  },
  'lipidease': {
    id: 'lipidease',
    name: 'LipidEase',
    price: 60,
    category: 'Heart Health',
    image: '',
    emoji: '❤️',
    tag: '',
    shortDesc: 'Targeted lipid support for cardiovascular wellness and healthy cholesterol.',
    fullDesc: "LipidEase is a doctor-formulated cardiovascular support supplement designed to promote healthy lipid levels and overall heart wellness. Combining powerful, research-backed ingredients like Bergamot Extract, CoQ10, and Plant Sterols, this formula works with your body\u2019s natural processes to support healthy cholesterol ratios and cardiovascular function.",
    ingredients: [
      'Citrus Bergamot Extract (500mg)', 'CoQ10 (100mg)', 'Plant Sterols (400mg)',
      'Omega-3 Fish Oil (300mg)', 'Red Yeast Rice (600mg)', 'Niacin (50mg)',
      'Garlic Extract (100mg)', 'Vitamin K2 (90mcg)'
    ],
    benefits: [
      { title: 'Healthy Cholesterol Support', desc: 'Bergamot and Plant Sterols help maintain cholesterol levels already within the normal range.' },
      { title: 'Cardiovascular Wellness', desc: 'CoQ10 and Omega-3 fatty acids provide essential support for heart muscle function and vascular health.' },
      { title: 'Antioxidant Protection', desc: 'Powerful antioxidants help protect cardiovascular tissue from oxidative stress and free radical damage.' },
      { title: 'Circulatory Support', desc: 'Garlic Extract and Niacin support healthy blood flow and vascular integrity.' }
    ],
    servingSize: '2 capsules daily with dinner',
    servings: '60 capsules (30-day supply)',
    reviews: [
      { name: 'Robert H.', initial: 'R', stars: 5, date: 'Feb 2026', text: 'My cholesterol numbers have improved significantly since starting LipidEase. My cardiologist is very pleased with the results.' },
      { name: 'Patricia W.', initial: 'P', stars: 5, date: 'Jan 2026', text: 'Finally a heart health supplement that uses quality ingredients. The bergamot extract really makes a difference.' },
      { name: 'James C.', initial: 'J', stars: 5, date: 'Dec 2025', text: 'Great product. I feel confident knowing I am supporting my heart health with clean, doctor-formulated ingredients.' }
    ]
  },
  'mitochondria-magic': {
    id: 'mitochondria-magic',
    name: 'Mitochondria Magic',
    price: 70,
    category: 'Cellular Energy',
    image: '',
    emoji: '⚡',
    tag: '',
    shortDesc: 'Fuel your cells with targeted mitochondrial support for sustained energy.',
    fullDesc: "Mitochondria Magic is Doc\u2019s premier cellular energy formula, designed to support and optimize your mitochondria \u2014 the powerhouses of every cell in your body. This advanced blend combines CoQ10, PQQ, and other targeted nutrients to boost energy production at the cellular level, support healthy aging, and enhance mental clarity without caffeine or stimulants.",
    ingredients: [
      'CoQ10 (200mg)', 'PQQ (20mg)', 'NAD+ Precursor (250mg)',
      'Alpha Lipoic Acid (200mg)', 'Acetyl L-Carnitine (500mg)', 'D-Ribose (1000mg)',
      'Magnesium Glycinate (200mg)', 'B-Complex (Full Spectrum)'
    ],
    benefits: [
      { title: 'Boosts Cellular Energy', desc: 'CoQ10 and D-Ribose fuel the electron transport chain, directly supporting ATP production in every cell.' },
      { title: 'Mitochondrial Biogenesis', desc: 'PQQ stimulates the creation of new mitochondria, expanding your cellular energy capacity over time.' },
      { title: 'Mental Clarity & Focus', desc: 'Acetyl L-Carnitine and NAD+ support brain energy metabolism for enhanced cognitive performance.' },
      { title: 'Healthy Aging Support', desc: 'Powerful antioxidants protect mitochondrial DNA and support graceful cellular aging.' }
    ],
    servingSize: '2 capsules daily in the morning',
    servings: '60 capsules (30-day supply)',
    reviews: [
      { name: 'James R.', initial: 'J', stars: 5, date: 'Feb 2026', text: 'Mitochondria Magic gives me clean, sustained energy without any crash. I can feel the difference in my workouts and daily life.' },
      { name: 'Lauren K.', initial: 'L', stars: 5, date: 'Jan 2026', text: 'Knowing these are small-batch, American-made, and doctor-formulated gives me so much confidence. Our whole family takes them now.' },
      { name: 'Thomas B.', initial: 'T', stars: 5, date: 'Jan 2026', text: 'The mental clarity I get from this supplement is incredible. No jitters, no crash \u2014 just clean, steady energy all day.' }
    ]
  }
};

// Active products (will be overridden by Shopify when connected)
let PRODUCTS = { ...DEFAULT_PRODUCTS };

// ====== HELPER: Render product image (supports Shopify images, local images, or emoji fallback) ======
function productImageHTML(product, size) {
  if (product.image) {
    return `<img src="${product.image}" alt="${product.name}" loading="lazy">`;
  }
  return product.emoji || '';
}

// ====== SHOPIFY BUY SDK INTEGRATION ======
let shopifyClient = null;
let shopifyCheckout = null;

async function initShopify() {
  if (!SHOPIFY_CONFIG.enabled || !SHOPIFY_CONFIG.domain || !SHOPIFY_CONFIG.storefrontToken) {
    console.log('Shopify not configured. Using default product data.');
    return false;
  }

  try {
    // Load Shopify Buy SDK
    if (typeof ShopifyBuy === 'undefined') {
      await loadScript('https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js');
    }

    shopifyClient = ShopifyBuy.buildClient({
      domain: SHOPIFY_CONFIG.domain,
      storefrontAccessToken: SHOPIFY_CONFIG.storefrontToken,
    });

    // Create a checkout
    shopifyCheckout = await shopifyClient.checkout.create();

    // Fetch all products from Shopify
    const products = await shopifyClient.product.fetchAll();

    // Convert Shopify products to our format
    PRODUCTS = {};
    products.forEach(p => {
      const handle = p.handle;
      const variant = p.variants[0];
      PRODUCTS[handle] = {
        id: handle,
        shopifyId: p.id,
        variantId: variant.id,
        name: p.title,
        price: parseFloat(variant.price.amount || variant.price),
        category: p.productType || 'Supplements',
        image: p.images[0] ? p.images[0].src : '',
        images: p.images.map(img => img.src),
        emoji: '',
        tag: p.tags && p.tags.length > 0 ? p.tags[0] : '',
        shortDesc: p.description ? p.description.substring(0, 120) + '...' : '',
        fullDesc: p.descriptionHtml || p.description || '',
        ingredients: [],  // Managed via Shopify metafields or description
        benefits: [],     // Managed via Shopify metafields or description
        servingSize: '',
        servings: '',
        reviews: []
      };
    });

    console.log(`Shopify connected: ${Object.keys(PRODUCTS).length} products loaded`);
    return true;
  } catch (err) {
    console.error('Shopify connection failed:', err);
    return false;
  }
}

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// ====== CART SYSTEM ======
// Uses localStorage for display, Shopify checkout for actual purchase
const Cart = {
  items: JSON.parse(localStorage.getItem('docsCart') || '[]'),

  save() {
    localStorage.setItem('docsCart', JSON.stringify(this.items));
    this.updateBadge();
  },

  async add(productId, qty = 1) {
    const product = PRODUCTS[productId];
    if (!product) return;
    const existing = this.items.find(i => i.id === productId);
    if (existing) {
      existing.quantity += qty;
    } else {
      this.items.push({
        id: product.id,
        shopifyVariantId: product.variantId || null,
        name: product.name,
        price: product.price,
        category: product.category,
        image: product.image || '',
        emoji: product.emoji || '',
        quantity: qty
      });
    }
    this.save();
    this.showToast(product.name);

    // Sync with Shopify checkout if connected
    if (shopifyCheckout && product.variantId) {
      try {
        shopifyCheckout = await shopifyClient.checkout.addLineItems(shopifyCheckout.id, [{
          variantId: product.variantId,
          quantity: qty
        }]);
      } catch (err) {
        console.error('Shopify cart sync error:', err);
      }
    }
  },

  remove(id) {
    this.items = this.items.filter(i => i.id !== id);
    this.save();
  },

  updateQuantity(id, qty) {
    const item = this.items.find(i => i.id === id);
    if (item) {
      item.quantity = Math.max(0, qty);
      if (item.quantity === 0) {
        this.remove(id);
      } else {
        this.save();
      }
    }
  },

  getSubtotal() {
    return this.items.reduce((sum, i) => sum + i.price * i.quantity, 0);
  },

  getCount() {
    return this.items.reduce((sum, i) => sum + i.quantity, 0);
  },

  getCheckoutUrl() {
    if (shopifyCheckout && shopifyCheckout.webUrl) {
      return shopifyCheckout.webUrl;
    }
    return null;
  },

  updateBadge() {
    document.querySelectorAll('.cart-badge').forEach(badge => {
      const count = this.getCount();
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  showToast(name) {
    const existing = document.querySelector('.toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.innerHTML = `<span class="toast-gold">Added:</span> ${name}`;
    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      toast.classList.add('show');
    });

    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 400);
    }, 2500);
  }
};

// ====== NAVBAR SCROLL ======
function initNavbar() {
  const navbar = document.getElementById('navbar');
  if (!navbar) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  });
}

// ====== MOBILE MENU ======
function initMobileMenu() {
  const hamburger = document.querySelector('.nav-hamburger');
  const menu = document.querySelector('.mobile-menu');
  const overlay = document.querySelector('.mobile-menu-overlay');
  if (!hamburger || !menu) return;

  function toggleMenu() {
    hamburger.classList.toggle('active');
    menu.classList.toggle('open');
    if (overlay) overlay.classList.toggle('open');
    document.body.style.overflow = menu.classList.contains('open') ? 'hidden' : '';
  }

  hamburger.addEventListener('click', toggleMenu);
  if (overlay) overlay.addEventListener('click', toggleMenu);

  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      if (menu.classList.contains('open')) toggleMenu();
    });
  });
}

// ====== SCROLL REVEAL ======
function initReveal() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const parent = entry.target.parentElement;
        const siblings = Array.from(parent.querySelectorAll('.reveal'));
        const index = siblings.indexOf(entry.target);
        setTimeout(() => {
          entry.target.classList.add('visible');
        }, index * 120);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
}

// ====== ADD TO CART BUTTONS ======
function initAddToCartButtons() {
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const productId = btn.getAttribute('data-add-to-cart');
      Cart.add(productId);
    });
  });
}

// ====== INIT ======
document.addEventListener('DOMContentLoaded', async () => {
  initNavbar();
  initMobileMenu();
  initReveal();
  Cart.updateBadge();

  // Try to connect to Shopify
  const shopifyConnected = await initShopify();

  // Init add-to-cart buttons (after products are loaded)
  initAddToCartButtons();

  // Dispatch event so page-specific scripts know products are ready
  window.dispatchEvent(new CustomEvent('productsReady', { detail: { shopify: shopifyConnected } }));
});
